import { render, staticRenderFns } from "./EditSuperBonus.vue?vue&type=template&id=2d34766d&scoped=true"
import script from "./EditSuperBonus.vue?vue&type=script&lang=js"
export * from "./EditSuperBonus.vue?vue&type=script&lang=js"
import style0 from "./EditSuperBonus.vue?vue&type=style&index=0&id=2d34766d&prod&lang=scss"
import style1 from "./EditSuperBonus.vue?vue&type=style&index=1&id=2d34766d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d34766d",
  null
  
)

export default component.exports